import { Alert, Button, OutlinedInput, Stack } from "@mui/material";
import React from "react";
import Modal, { CommonModalProps } from "..";
import { userService } from "../../../Core/Api/services";
import { LoginResponse } from "../../../Core/Api/Types/login-response";
import useCustomSnackbar from "../../../Utils/Hooks/useCustomSnackbar";
import FormInputText from "../../Forms/FormInputText/form-input-text";
import { useTranslation } from "react-i18next";

export type ModalMfaValidateTokenElementProps = {
  login: string;
  password: string;
  onLoginCallback: (login: string | null, password: string | null, response: LoginResponse) => void;
  onClose: () => void;
};

export type ModalMfaValidateTokenProps = CommonModalProps<ModalMfaValidateTokenElementProps>;

const ModalMfaValidateToken = React.forwardRef<any, ModalMfaValidateTokenProps>((props, ref) => {
  const { t } = useTranslation();
  const { login, password, onLoginCallback, onClose, closeModal } = props;
  const enqueueCustomSnackbar = useCustomSnackbar();

  const [inputToken, setInputToken] = React.useState<string>("");

  const handleConfirmClick = () => {
    userService.ValidateMfaToken({ login, password, token: inputToken }).then((response) => {
      if (!response.success) {
        enqueueCustomSnackbar(response.message || t("alert:error.oopsSomethingWentWrong"), "warning");
      }

      if (
        response.rescode === -902 || // token not found
        response.rescode === -904 || // max attempts (super user)
        response.rescode === -905 || // max attempts
        response.rescode === -906 // token expired
      )
        handleCancelClick();

      if (response.success) {
        onLoginCallback(login, password, response);
        handleCancelClick();
      }
    });
  };

  const handleCancelClick = () => {
    onClose();
    closeModal();
  };

  return (
    <Modal
      title={t("modal:title.validateToken")}
      reference={ref}
      closeModal={handleCancelClick}
      width={600}
      footer={
        <Stack direction="row" justifyContent="space-between">
          <Button onClick={handleCancelClick}>{t("common:cancel")}</Button>
          <Button color="success" variant="outlined" onClick={handleConfirmClick}>
            {t("common:confirm")}
          </Button>
        </Stack>
      }
    >
      <Stack spacing={1}>
        <FormInputText
          label={t("field:label.enterYourSecureCode")}
          value={inputToken}
          onChange={(e) => setInputToken(e.target.value)}
          placeholder={t("field:placeholder.enterYourSecurityCode")}
          validationProps={{
            formId: "mfa-validate-token",
            fieldId: "mfa-validate-token",
            required: true,
            minLength: 6,
            maxLength: 6,
            regexPattern: /\d{6}/,
          }}
        />

        <Alert severity="info">{t("alert:info.enterCodeSentYouBySmsOrMail")}</Alert>
      </Stack>
    </Modal>
  );
});

export default ModalMfaValidateToken;
